import type { HttpTransport } from '@mangovoice/api-client'
import type { BlockedNumber, PaginatedApiResult } from '@mangovoice/types'
import type { components } from '@mangovoice/types/generated/mango-api'

export interface BlockNumberRequest {
  pbx_id: number
  phone_number: string
}

export type BlockNumberResponse = components['schemas']['BlockedNumberCreate']

export function createBlockedNumbersResource(transport: HttpTransport) {
  return {
    getBlockedNumbers: (pbxId: number) =>
      transport.get<PaginatedApiResult<BlockedNumber>>(
        `/blocked-numbers/?pbx_id=${pbxId}&limit=9999`,
      ),

    blockNumber: (pbxId: number, phoneNumber: string) =>
      transport.post<BlockNumberResponse>('/blocked-numbers/', {
        pbx_id: pbxId,
        phone_number: phoneNumber,
      }),

    unblockNumber: (blockedNumberId: number) =>
      transport.delete<void>(`/blocked-numbers/${blockedNumberId}/`),
  }
}
